export const MAPPING_SKIP_KEY = "__skip";

export const MAX_IMPORT_ROWS_COUNT = 100000;
